import { DateSeparatorProps } from 'stream-chat-react';
import { format, isSameDay } from 'date-fns';
import React, { useContext, useMemo } from 'react';
import { Text, theme } from 'components';
import styled from 'styled-components';
import { getLocalTimeZone, getStartOfDayInTimezone } from 'utils';
import { AuthContext } from 'contexts';

const CustomMessageDate = (props: DateSeparatorProps) => {
  const { auth } = useContext(AuthContext);
  const { date } = props;
  const formattedDate = useMemo(
    () =>
      isSameDay(
        getStartOfDayInTimezone(date, getLocalTimeZone(auth)),
        getStartOfDayInTimezone(new Date(), getLocalTimeZone(auth)),
      )
        ? 'Today'
        : format(new Date(date), 'MM/dd/yyyy'),
    [date],
  );
  return (
    <StyledDateContainer>
      <Text color={theme.textColorSecondary} fontSize={12} strong>
        {formattedDate}
      </Text>
    </StyledDateContainer>
  );
};

const StyledDateContainer = styled.div`
  text-align: center;
`;

export default CustomMessageDate;
